import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_gmmstz6ge7: FaireCollectionEntity = {
  token: "pbc_gmmstz6ge7",
  type: "collection",
  name: "The Final Markdowns",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bf51e857daa7d0c25cd854cab2c88761e377eb2e8c75e6ba15fa0b8f91b80afb.jpeg",
  itemCount: 19,
  description:
    "Score the best deals of the season with The Final Markdowns, your last chance to grab Judy Blue’s most-loved styles at their absolute lowest wholesale prices before they're gone for good!",
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:15.794Z",
    importedBy: "entity-db-import-collections",
  },
};
